const languages = [
  { id: 'en', value: 'English', img: 'flagus' },
  { id: 'sp', value: 'Español', img: 'flagsp' }
];

export default languages;


